import { html } from '@polymer/polymer/polymer-element.js';
import { KatapultWidget } from './katapult-widget';
import '@polymer/paper-card';
import '@polymer/paper-tabs';
import '@polymer/paper-dialog/paper-dialog.js';
import '@polymer/iron-pages/iron-pages.js';
import '../../katapult-dialog-legacy/katapult-dialog-legacy';
import '../../katapult-auth/katapult-auth';

class KatapultReferenceWidget extends KatapultWidget {
  static get is() {
    return 'katapult-reference-widget';
  }

  static get widgetTitleTemplate() {
    return html` <span>Reference Library</span> `;
  }

  static get primaryControlTemplate() {
    return html`
      <span>
        <material-icon icon="search" style="font-size: 18px"></material-icon>
      </span>
    `;
  }
  // Title in top left of widget
  static get headerTemplate() {
    return html` <span>Reference Library</span> `;
  }

  static get headerEndTemplate() {
    return html``;
  }

  // Content of dropdown body
  static get contentTemplate() {
    return html`
      <style is="custom-style">
        #result {
          border: 1px solid black;
          background: white;
          border-top: none;
          width: 330px;
          margin-right: 0px;
          display: block;
          visibility: hidden;
        }

        div:empty {
          display: none;
        }

        #result ul {
          list-style-type: none;
          padding: 0px;
          margin: 0px;
          padding: 0px;
        }

        #result ul li {
          padding: 5px 0px;
        }

        #result ul li:hover {
          background: #eee;
        }

        #input {
          width: 325px;
          height: 24px;
          font: Roboto;
          font-size: 14.6667;
          border: 1px solid black;
        }

        #input:hover,
        #input:focus {
          border: 1.5px solid #007299;
          background-color: white;
        }

        #searchButton {
          margin-top: 5px;
          border: 1px solid black;
        }
      </style>

      <form autocomplete="off" onSubmit="return false;" id="form">
        <input
          id="input"
          placeholder="Search For Documents Here"
          type="text"
          on-click="showResultsBox"
          on-keyup="showResults"
          on-keypress="enterSearch"
        />
        <div id="result" on-click="fillResults"></div>
        <katapult-button class="button" id="searchButton" on-click="searchDatabase">Search</katapult-button>
      </form>
    `;
  }

  // Body
  static get bodyTemplate() {
    return html`
      <style is="custom-style">
        .card {
          width: 424px;
          height: 450px;
        }

        .card-content {
          height: 220px;
        }

        .card-actions {
          height: 50px;
        }

        .button {
          color: white;
          background: #007299;
          height: 30px;
        }

        .header {
          background: #007299;
        }

        .tab-header {
          color: white;
          padding-left: 10px;
        }

        .myCollapseIcon {
          color: white;
          cursor: pointer;
          flex-direction: right;
        }

        #cardContent {
          display: none;
        }

        #createButton {
          margin-top: 8px;
        }

        #editTitle {
          padding-left: 0px;
          color: white;
          margin-left: 14.667px;
        }

        #editTitle:focus {
          background: white;
          color: black;
          border: 1px solid black;
        }

        #saveButton {
          display: none;
        }

        .content-1 {
          margin-top: 0px;
          margin-bottom: 0px;
          height: 360px;
          width: 792px;
        }

        #result1 {
          border: 1px solid black;
          background: white;
          width: 792px;
          height: 360px;
          overflow: auto;
        }

        #result2 {
          border: 1px solid black;
          background: white;
          width: 792px;
          height: 360px;
          overflow: auto;
        }

        div:empty {
          display: none;
        }

        #result1 ul {
          list-style-type: none;
          padding: 0;
          margin: 0;
          padding: 0;
        }

        #result1 ul li {
          padding: 5px 0;
        }

        #result1 ul li:hover {
          background: #eee;
        }

        #result2 ul {
          list-style-type: none;
          padding: 0;
          margin: 0;
          padding: 0;
        }

        #result2 ul li {
          padding: 5px 0;
        }

        #result2 ul li:hover {
          background: #eee;
        }

        #cardContent1 {
          display: none;
        }

        #cardContent2 {
          display: none;
        }

        #closeButton {
          display: none;
          margin-top: 8px;
        }

        #clearButton {
          display: none;
        }

        #confirmMessage {
          font-weight: normal;
        }

        .dialog {
          border-radius: 20px;
          padding: 8px;
        }

        .formQuestion {
          margin-bottom: 0px;
        }

        #dialogButton1 {
          margin-left: 116px;
          margin-bottom: 5px;
          margin-top: 5px;
        }

        #img {
          display: none;
          width: 100%;
          height: 360px;
        }

        #iframe {
          display: none;
          width: 100%;
          height: 360px;
        }

        #card3 {
          width: 100%;
        }

        #card2 {
          width: 100%;
        }

        #card1 {
          width: 100%;
        }
      </style>

      <div id="cardContent">
        <paper-card class="card" id="card1">
          <paper-header shrink class="header">
            <p class="tab-header" id="editTitle" contenteditable="true">New Document</p>
          </paper-header>

          <div class="card-content">
            <p id="content" class="content-1" contenteditable="true"></p>
          </div>
        </paper-card>
      </div>

      <paper-dialog id="dialog" class="dialog">
        <h1 id="confirmMessage">Confirm Exit?</h1>
        <katapult-button class="button" dialog-dismiss>Cancel</katapult-button>
        <katapult-button class="button" dialog-confirm autofocus on-click="closeDocument">Close</katapult-button>
      </paper-dialog>
      <paper-dialog id="dialog1" class="dialog">
        <h1 id="confirmMessage">Responses Recorded!</h1>
        <katapult-button class="button" dialog-confirm autofocus on-click id="dialogButton1">Close</katapult-button>
      </paper-dialog>

      <katapult-dialog-legacy id="formDialog" no-cancel-on-outside-click draggable close-button style="width: 500px;">
        <span slot="title">Suggestions Form</span>
        <div slot="body">
          <p class="formQuestion">What is your Katapult Email?</p>
          <paper-input placeholder="Enter Here" id="formAnswer1"></paper-input>
          <p class="formQuestion">What resources do you find critical for me to make accessible?</p>
          <paper-input placeholder="Enter Here" id="formAnswer2"></paper-input>
          <p class="formQuestion">Where can I access these critical resources?</p>
          <paper-input placeholder="Enter Here" id="formAnswer3"></paper-input>
          <p class="formQuestion">What could I add to this widget?</p>
          <paper-input placeholder="Enter Here" id="formAnswer4"></paper-input>
        </div>
        <div slot="buttons">
          <katapult-button class="button" id="submitButton" on-click="submitForm">Submit</katapult-button>
        </div>
      </katapult-dialog-legacy>

      <div id="cardContent1">
        <paper-card class="card" id="card2">
          <paper-header shrink class="header">
            <p class="tab-header" id="cardHeader"></p>
          </paper-header>

          <div class="card-content">
            <form id="content" class="content-1">
              <div id="result1" on-click="openDocument">
                <ul id="libraryResult"></ul>
              </div>
            </form>
          </div>
        </paper-card>
      </div>

      <div id="cardContent2">
        <paper-card class="card" id="card3">
          <paper-header shrink class="header">
            <p class="tab-header" id="cardHeader2">Frequently Accessed Resources</p>
          </paper-header>

          <div class="card-content">
            <iframe id="iframe" src=""></iframe>
            <img id="img" src="" />
            <form id="content1" class="content-1">
              <div id="result2" on-click="openFARDocument">
                <ul id="libraryResult1"></ul>
              </div>
            </form>
          </div>
        </paper-card>
      </div>

      <katapult-button class="button" id="createButton" on-click="newDocument">New</katapult-button>
      <katapult-button class="button" id="closeButton" on-click="closeCheck">Close</katapult-button>
      <katapult-button class="button" id="openButton" on-click="openDocumentLibrary">Open</katapult-button>
      <katapult-button class="button" id="saveButton" on-click="saveCheck">Save</katapult-button>
      <katapult-button class="button" id="farButton" on-click="openFAR" title="Frequently Accessed Resources">F.A.R.</katapult-button>
      <katapult-button class="button" id="clearButton" on-click="clearFirebase">Clear</katapult-button>
      <katapult-button class="button" id="formButton" on-click="openForm">Suggestions</katapult-button>
    `;
  }

  static get properties() {
    return {
      paperHeader: {
        type: Boolean,
        value: true //false is default
      },
      primaryControl: {
        type: Boolean,
        value: true
      },
      icon: {
        type: String,
        value: 'search'
      },
      selectedTab: {
        type: Number,
        value: 0
      },

      docs: {
        type: Array,
        value: () => []
      }
    };
  }

  ready() {
    super.ready();
  }

  // Functions

  // Open an iframe document
  async openFARiFrame(title) {
    if (title == 'Handoffs') {
      let url = await this.getimgURL('reference_documents/handoffs.xlsx');

      this.shadowRoot.getElementById('iframe').style.display = 'block';
      this.shadowRoot.getElementById('cardHeader2').innerText = title;
      this.shadowRoot.getElementById('result2').style.display = 'none';

      this.shadowRoot.getElementById('iframe').src = url;
    } else if (title == 'Overheads') {
      let url = await this.getimgURL('reference_documents/overhead_pole_line_construction.docx');

      this.shadowRoot.getElementById('iframe').style.display = 'block';
      this.shadowRoot.getElementById('cardHeader2').innerText = title;
      this.shadowRoot.getElementById('result2').style.display = 'none';

      this.shadowRoot.getElementById('iframe').src = url;
    } else if (title == 'Intern Support Doc') {
      let url = await this.getimgURL('reference_documents/intern_support_doc.pdf');

      this.shadowRoot.getElementById('iframe').style.display = 'block';
      this.shadowRoot.getElementById('cardHeader2').innerText = title;
      this.shadowRoot.getElementById('result2').style.display = 'none';

      this.shadowRoot.getElementById('iframe').src = url;
    } else if (title == 'PMR Links') {
      let url = await this.getimgURL('reference_documents/PMRHelpfulLinks.pdf');

      this.shadowRoot.getElementById('iframe').style.display = 'block';
      this.shadowRoot.getElementById('cardHeader2').innerText = title;
      this.shadowRoot.getElementById('result2').style.display = 'none';

      this.shadowRoot.getElementById('iframe').src = url;
    }
  }

  // Open an image
  async openFARimage(title) {
    if (title == 'Katapult') {
      let url = await this.getimgURL('reference_documents/katapultLogo.png');

      this.shadowRoot.getElementById('img').style.display = 'block';
      this.shadowRoot.getElementById('cardHeader2').innerText = title;
      this.shadowRoot.getElementById('result2').style.display = 'none';

      this.shadowRoot.getElementById('img').src = url;
    }
  }

  // Open a F.A.R. Document
  async openFARDocument() {
    this.shadowRoot.getElementById('libraryResult1').addEventListener('click', (e) => {
      var title = '';

      title = e.target.innerText;

      if (title == 'Katapult') {
        this.openFARimage(title);
      } else if (title == 'Handoffs') {
        this.openFARiFrame(title);
      } else if (title == 'Intern Support Doc') {
        this.openFARiFrame(title);
      } else if (title == 'Overheads') {
        this.openFARiFrame(title);
      } else if (title == 'PMR Links') {
        this.openFARiFrame(title);
      }
    });
  }

  // Open frequently accessed resources
  async openFAR() {
    let userGroup = document.querySelector('katapult-home').userGroup;
    let userInfo = document.querySelector('katapult-home').user;

    this.shadowRoot.getElementById('cardContent2').style.display = 'block';
    this.shadowRoot.getElementById('cardContent1').style.display = 'none';
    this.shadowRoot.getElementById('cardContent').style.display = 'none';
    this.shadowRoot.getElementById('createButton').style.display = 'none';
    this.shadowRoot.getElementById('saveButton').style.display = 'none';
    this.shadowRoot.getElementById('closeButton').style.display = 'var(--layout-inline_-_display)';
    this.shadowRoot.getElementById('cardHeader2').innerText = 'Frequently Accessed Resources';
    this.shadowRoot.getElementById('libraryResult1').innerText = '';
    this.shadowRoot.getElementById('img').style.display = 'none';
    this.shadowRoot.getElementById('iframe').style.display = 'none';
    this.shadowRoot.getElementById('result2').style.display = 'block';

    const userData = await FirebaseWorker.ref(`/photoheight/company_space/${userGroup}/user_data/${userInfo.uid}/home/ref_docs/MyDocs`)
      .once('value')
      .then((s) => s.val());

    let docs = [];
    docs = ['Katapult', 'Handoffs', 'Intern Support Doc', 'Overheads', 'PMR Links'];

    let library = '';

    for (let i = 0; i < docs.length; i++) {
      library += '<li>' + docs[i] + '</li>';
    }

    if (docs.length == 0) {
      this.shadowRoot.getElementById('libraryResult1').innerHTML = '<li>No Saved Documents</li>';
    } else {
      this.shadowRoot.getElementById('libraryResult1').innerHTML = library;
    }
  }

  // Submit button for form
  async submitForm() {
    let userGroup = document.querySelector('katapult-home').userGroup;

    // Assigning the inputs to variables
    var q1 = this.shadowRoot.getElementById('formAnswer1').value;
    var q2 = this.shadowRoot.getElementById('formAnswer2').value;
    var q3 = this.shadowRoot.getElementById('formAnswer3').value;
    var q4 = this.shadowRoot.getElementById('formAnswer4').value;

    // Pushing the form inputs into firebase
    await firebase.database().ref(`/photoheight/company_space/${userGroup}/user_data/aqISIFJqYQXOvIyMLQTBg18zE0q1/home/suggestions`).push({
      Email: q1,
      Resources: q2,
      ResourceLocation: q3,
      Additions: q4
    });

    this.shadowRoot.getElementById('dialog1').open();
    this.shadowRoot.getElementById('formDialog').close();
  }

  // Toggle form dialog box
  async openForm() {
    this.shadowRoot.getElementById('formDialog').open();

    this.shadowRoot.getElementById('formAnswer1').value = '';
    this.shadowRoot.getElementById('formAnswer2').value = '';
  }

  // Toggle dialog box
  async closeCheck() {
    if (
      this.shadowRoot.getElementById('cardContent1').style.display == 'none' &&
      this.shadowRoot.getElementById('cardContent2').style.display == 'none'
    ) {
      this.shadowRoot.getElementById('dialog').toggle();
    } else {
      this.closeDocument();
    }
  }

  // Change content when "Close Document" button is clicked
  async closeDocument() {
    this.shadowRoot.getElementById('cardContent').style.display = 'none';
    this.shadowRoot.getElementById('cardContent1').style.display = 'none';
    this.shadowRoot.getElementById('cardContent2').style.display = 'none';
    this.shadowRoot.getElementById('createButton').style.display = 'var(--layout-inline_-_display)';
    this.shadowRoot.getElementById('openButton').style.display = 'var(--layout-inline_-_display)';
    this.shadowRoot.getElementById('closeButton').style.display = 'none';
    this.shadowRoot.getElementById('saveButton').style.display = 'none';
    this.shadowRoot.getElementById('farButton').style.display = 'var(--layout-inline_-_display)';
    this.shadowRoot.getElementById('content').style.display = 'block';
  }

  async getimgURL(path) {
    let url = await firebase.storage().ref(path).getDownloadURL();
    return url;
  }

  // Clear firebase
  async clearFirebase() {
    let userGroup = document.querySelector('katapult-home').userGroup;
    let userInfo = document.querySelector('katapult-home').user;

    //  await firebase.database().ref(`/photoheight/company_space/${userGroup}/user_data/${userInfo.uid}/home/suggestions/-N-3-jSVXms_TXymy_Qq`).once('value',(snap) => {
    //   let data = snap.val();
    // });

    //  await firebase.database().ref(`/photoheight/company_space/${userGroup}/user_data/${userInfo.uid}/home/ref_docs`).({
    //    MyDocs: []
    //  });

    // await firebase.database().ref(`/photoheight/company_space/${userGroup}/user_data/${userInfo.uid}/home/ref_docs/MyDocs`).push({
    //   title: "empty",
    //   content: "empty"
    // });

    //  let url = await firebase.storage().ref('reference_documents/katapultLogo.png').getDownloadURL();
  }

  // Open document from document library
  async openDocument() {
    let userGroup = document.querySelector('katapult-home').userGroup;
    let userInfo = document.querySelector('katapult-home').user;

    this.shadowRoot.getElementById('content').style.display = 'block';
    // Array with title field from firebase
    var titleDocs = [];
    // Array with content field from firebase
    var contentDocs = [];
    await firebase
      .database()
      .ref(`/photoheight/company_space/${userGroup}/user_data/${userInfo.uid}/home/ref_docs/MyDocs`)
      .once('value', (snap) => {
        let data = snap.val();

        let length = Object.keys(data).length;

        // Loop to push title field into array from firebase
        for (let i = 0; i < length; i++) {
          titleDocs.push(data[Object.keys(data)[i]].title);
          contentDocs.push(data[Object.keys(data)[i]].content);
        }
      });

    // On click event that populates the card with data from firebase
    this.shadowRoot.getElementById('libraryResult').addEventListener('click', (e) => {
      var title = '';

      title = e.target.innerHTML;
      //let title = "Overheads";

      if (title) {
        this.shadowRoot.getElementById('cardContent1').style.display = 'none';
        this.shadowRoot.getElementById('cardContent').style.display = 'block';
        this.shadowRoot.getElementById('createButton').style.display = 'none';
        this.shadowRoot.getElementById('saveButton').style.display = 'var(--layout-inline_-_display)';
        this.shadowRoot.getElementById('openButton').style.display = 'none';

        // For loop that goes through firebase and finds the according title and content that was selected
        for (let i = 0; i < titleDocs.length; i++) {
          // docs.push(data[Object.keys(data)[i]].title);
          // let exi = titleDocs[i];
          if (title == titleDocs[i]) {
            this.shadowRoot.getElementById('editTitle').innerHTML = titleDocs[i];
            this.shadowRoot.getElementById('content').innerHTML = contentDocs[i];
          }
        }
      }
    });
  }

  // Open document Library
  async openDocumentLibrary() {
    let userGroup = document.querySelector('katapult-home').userGroup;
    let userInfo = document.querySelector('katapult-home').user;

    this.shadowRoot.getElementById('cardContent1').style.display = 'block';
    this.shadowRoot.getElementById('cardContent2').style.display = 'none';
    this.shadowRoot.getElementById('cardContent').style.display = 'none';
    this.shadowRoot.getElementById('createButton').style.display = 'none';
    this.shadowRoot.getElementById('saveButton').style.display = 'none';
    this.shadowRoot.getElementById('closeButton').style.display = 'var(--layout-inline_-_display)';
    this.shadowRoot.getElementById('cardHeader').innerText = 'Document Library';

    var docs = [];

    const userData = await FirebaseWorker.ref(`/photoheight/company_space/${userGroup}/user_data/${userInfo.uid}/home/ref_docs/MyDocs`)
      .once('value')
      .then((s) => s.val());

    if (!userData) {
      this.shadowRoot.getElementById('libraryResult').innerHTML = '<li>No Saved Documents</li>';
    } else {
      // Firebase call that gets the every title and pushes it into the 'docs' array
      await firebase
        .database()
        .ref(`/photoheight/company_space/${userGroup}/user_data/${userInfo.uid}/home/ref_docs/MyDocs`)
        .once('value', (snap) => {
          let data = snap.val();

          let length = Object.keys(data).length;

          for (let i = 0; i < length; i++) {
            docs.push(data[Object.keys(data)[i]].title);
          }
        });

      // Populating the HTML with the all of the titles from Firebase
      let library = '';

      for (let i = 0; i < docs.length; i++) {
        library += '<li>' + docs[i] + '</li>';
      }

      if (docs.length == 0) {
        this.shadowRoot.getElementById('libraryResult').innerHTML = '<li>No Saved Documents</li>';
      } else {
        this.shadowRoot.getElementById('libraryResult').innerHTML = library;
      }
    }
  }

  // Check to see if document exists then either save or edit entry in firebase
  async saveCheck() {
    let userGroup = document.querySelector('katapult-home').userGroup;
    let userInfo = document.querySelector('katapult-home').user;

    let content = this.shadowRoot.getElementById('content').innerHTML;
    let title = this.shadowRoot.getElementById('editTitle').innerHTML;

    const userData = await FirebaseWorker.ref(`/photoheight/company_space/${userGroup}/user_data/${userInfo.uid}/home/ref_docs/MyDocs`)
      .once('value')
      .then((s) => s.val());

    if (!userData) {
      this.saveNewDocument(title, content);
    } else {
      // Get all data from firebase and compare title to all of the titles in firebase currently
      await firebase
        .database()
        .ref(`/photoheight/company_space/${userGroup}/user_data/${userInfo.uid}/home/ref_docs/MyDocs`)
        .once('value')
        .then((snap) => {
          let data = snap.val();
          let length = Object.keys(data).length;
          // State variable to break the for loop and save correctly
          var state = 0;

          // For loop to loop through each title in firebase
          for (let i = 0; i < length; i++) {
            let exiTitle = data[Object.keys(data)[i]].title;
            // If title is in firebase save it to the title
            if (exiTitle == title) {
              state = 1;
              this.saveExiDocument(title, content);
              break;
            }
          }
          // If title is not in firebase save it to a new UID
          if (state == 0) {
            this.saveNewDocument(title, content);
          }
        });
    }
  }

  // Save existing document's content
  async saveExiDocument(title, content) {
    let userGroup = document.querySelector('katapult-home').userGroup;
    let userInfo = document.querySelector('katapult-home').user;
    var uid = '';
    var exiTitle = '';

    // Get UID that corresponds to the title and content passed from saveCheck()
    await firebase
      .database()
      .ref(`/photoheight/company_space/${userGroup}/user_data/${userInfo.uid}/home/ref_docs/MyDocs`)
      .once('value')
      .then((snap) => {
        let data = snap.val();

        let length = Object.keys(data).length;

        for (let i = 0; i < length; i++) {
          if (title == data[Object.keys(data)[i]].title) {
            uid = [Object.keys(data)[i]];
            exiTitle = data[Object.keys(data)[i]].title;
          }
        }
      });

    //Save new content to the existing corresponding title
    await firebase.database().ref(`/photoheight/company_space/${userGroup}/user_data/${userInfo.uid}/home/ref_docs/MyDocs/${uid}`).update({
      content: content
    });
  }

  // Save document
  async saveNewDocument(title, content) {
    let userGroup = document.querySelector('katapult-home').userGroup;
    let userInfo = document.querySelector('katapult-home').user;

    // Push new content and title into firebase
    await firebase.database().ref(`/photoheight/company_space/${userGroup}/user_data/${userInfo.uid}/home/ref_docs/MyDocs`).push({
      title: title,
      content: content
    });
  }

  // Change content when "New Document" button is clicked
  async newDocument() {
    this.shadowRoot.getElementById('cardContent').style.display = 'block';
    this.shadowRoot.getElementById('content').innerText = '';
    this.shadowRoot.getElementById('editTitle').innerText = 'New Document';
    this.shadowRoot.getElementById('cardContent1').style.display = 'none';
    this.shadowRoot.getElementById('createButton').style.display = 'none';
    this.shadowRoot.getElementById('closeButton').style.display = 'var(--layout-inline_-_display)';
    this.shadowRoot.getElementById('saveButton').style.display = 'var(--layout-inline_-_display)';
    this.shadowRoot.getElementById('openButton').style.display = 'none';
    this.shadowRoot.getElementById('farButton').style.display = 'none';
  }

  // User clicks on a suggestion it fills the input box with it
  async fillResults() {
    this.shadowRoot.getElementById('result').addEventListener('click', (e) => {
      var fill = '';
      fill = e.target.innerHTML;
      if (fill.charAt(0) == ' ') {
        fill = '';
        this.shadowRoot.getElementById('input').value = fill;
        this.shadowRoot.getElementById('input').focus();
      } else {
        this.shadowRoot.getElementById('input').value = fill;
        this.shadowRoot.getElementById('input').focus();
      }
    });
  }

  // Complete search when user hits enter
  async enterSearch() {
    this.shadowRoot.getElementById('input').addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        this.shadowRoot.getElementById('searchButton').click();
      }
    });
  }

  // Show results box when input box is clicked
  async showResultsBox() {
    if (this.shadowRoot.getElementById('input').value == '') {
      this.shadowRoot.getElementById('result').style.visibility = 'hidden';
    } else {
      this.shadowRoot.getElementById('result').style.visibility = 'visible';
    }
  }

  // Autocomplete and suggestions for search bar
  async showResults() {
    let val = this.shadowRoot.getElementById('input').value;
    let suggestions = '';
    let docs = await this.autoCompleteMatch(val);

    for (let i = 0; i < docs.length; i++) {
      suggestions += '<li>' + docs[i] + '</li>';
    }

    if (docs.length == 0) {
      this.showResultsBox();
      this.shadowRoot.getElementById('result').innerText = '';
    } else {
      this.showResultsBox();
      this.shadowRoot.getElementById('result').innerHTML = '<ul>' + suggestions + '</ul>';
    }
  }

  // Help function to match input to firebase
  async autoCompleteMatch(input) {
    // Getting user info
    let userGroup = document.querySelector('katapult-home').userGroup;
    let userInfo = document.querySelector('katapult-home').user;
    var docs = new Array();
    // console.log(input)

    // Call firebase and read data
    // firebase.database().ref(`/photoheight/company_space/${userGroup}/user_data/${userInfo.uid}/ref_docs/MyDocs`).once('value',(snap) => {
    await firebase
      .database()
      .ref(`/photoheight/company_space/${userGroup}/user_data/${userInfo.uid}/home/ref_docs/MyDocs`)
      .once('value')
      .then((snap) => {
        // MyDocs array is in data
        let data = snap.val();

        // console.log(data);
        // console.log(Object.keys(data)[0]);

        // console.log(data[Object.keys(data)[0]].content);

        // console.log(data[Object.keys(data)[0]].title);

        // console.log(Object.keys(data).length);

        let length = Object.keys(data).length;

        // console.log(data[Object.keys(data)[0]].title);

        // If input is empty
        if (input == '') {
          return [];
        }

        for (let i = 0; i < length; i++) {
          let text = data[Object.keys(data)[i]].title;
          for (let j = 0; j < text.length; j++) {
            if (input.charAt(j).toLowerCase() == text.charAt(j).toLowerCase()) {
              if (!docs.includes(data[Object.keys(data)[i]].title)) docs.push(data[Object.keys(data)[i]].title);
            }
          }
        }
      });
    return docs;
  }

  //Search firebase real-time database
  async searchDatabase() {
    // Getting user info
    let userGroup = document.querySelector('katapult-home').userGroup;
    let userInfo = document.querySelector('katapult-home').user;
    let searchInput = this.shadowRoot.getElementById('input').value;

    // Get MyDocs array from database containing all documents
    await firebase
      .database()
      .ref(`/photoheight/company_space/${userGroup}/user_data/${userInfo.uid}/home/ref_docs/MyDocs`)
      .once('value', (snap) => {
        let data = snap.val();
        // console.log(data);

        let length = Object.keys(data).length;

        //  If search input equals a title paste into card below
        for (let i = 0; i < length; i++) {
          if (data[Object.keys(data)[i]].title.toLowerCase() == searchInput.toLowerCase()) {
            let title = data[Object.keys(data)[i]].title;
            let content = data[Object.keys(data)[i]].content;
            this.shadowRoot.getElementById('createButton').click();
            this.shadowRoot.getElementById('editTitle').innerText = title;
            this.shadowRoot.getElementById('content').innerHTML = content;
            this.shadowRoot.getElementById('cardContent2').style.display = 'none';
            break;
          }
        }
      });
  }

  // Reading and writing to database
  async getDatabase() {
    let userGroup = document.querySelector('katapult-home').userGroup;
    let userInfo = document.querySelector('katapult-home').user;

    // Write
    await firebase
      .database()
      .ref(`/photoheight/company_space/${userGroup}/user_data/${userInfo.uid}/home/ref_docs`)
      .set({
        Favorite: ['example', 'example1'],
        MyDocs: ['Doc1', 'Doc2', 'A', 'B', 'Overheads', 'Handoffs', 'Pole Info']
      });

    // Read
    await firebase
      .database()
      .ref(`/photoheight/company_space/${userGroup}/user_data/${userInfo.uid}/home/ref_docs/MyDocs`)
      .once('value', (snap) => {
        let data = snap.val();
      });
  }
}

window.customElements.define('katapult-reference-widget', KatapultReferenceWidget);
